'use es6';

import { List, Record } from 'immutable';
import MAB from './MAB';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  experiments: List(),
  status: RequestStatus.UNINITIALIZED
};
export default class MABPastExperiments extends Record(DEFAULTS) {
  static fromJS(data) {
    return new MABPastExperiments({
      experiments: List(data).map(MAB.fromJS).sortBy(mab => -mab.experiment.deletedAt),
      status: RequestStatus.SUCCEEDED
    });
  }

}